import React, { useState } from 'react';
import { InstitutionList } from './institutions/InstitutionList';
import { SimulationManager } from './simulations/SimulationManager';
import { ModuleManager } from './modules/ModuleManager';
import { InstitutionDetails } from './institutions/InstitutionDetails';
import { useAuthStore } from '../../lib/store-auth';
import { useAdminStore } from '../../lib/store-admin';
import './admin.scss';

interface AdminLayoutProps {
    onLogout: () => void;
    onViewReport: () => void;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ onLogout, onViewReport }) => {
    const [activeTab, setActiveTab] = useState<'institutions' | 'simulations' | 'modules'>('institutions');
    const { user } = useAuthStore();
    const { selectedInstitution } = useAdminStore();

    return (
        <div className="admin-layout">
            <aside className="admin-sidebar">
                <div className="sidebar-header">
                    <img src="/logo.svg" alt="Saletone Admin" />
                    <span>Admin Paneli</span>
                </div>

                <nav className="sidebar-nav">
                    <button
                        className={`nav-item ${activeTab === 'institutions' ? 'active' : ''}`}
                        onClick={() => setActiveTab('institutions')}
                    >
                        <span className="material-symbols-outlined">apartment</span>
                        Kurumlar
                    </button>
                    <button
                        className={`nav-item ${activeTab === 'simulations' ? 'active' : ''}`}
                        onClick={() => setActiveTab('simulations')}
                    >
                        <span className="material-symbols-outlined">smart_toy</span>
                        Simülasyonlar
                    </button>
                    <button
                        className={`nav-item ${activeTab === 'modules' ? 'active' : ''}`}
                        onClick={() => setActiveTab('modules')}
                    >
                        <span className="material-symbols-outlined">school</span>
                        Modüller
                    </button>
                </nav>

                <div className="sidebar-footer">
                    <div className="user-info">
                        <span className="user-name">{user?.full_name}</span>
                        <span className="user-role">Admin</span>
                    </div>
                    <button className="logout-btn" onClick={onLogout}>
                        <span className="material-symbols-outlined">logout</span>
                    </button>
                </div>
            </aside>

            <main className="admin-content">
                {activeTab === 'institutions' ? (
                    selectedInstitution ? (
                        <InstitutionDetails onViewReport={onViewReport} />
                    ) : (
                        <InstitutionList />
                    )
                ) : activeTab === 'simulations' ? (
                    <SimulationManager />
                ) : (
                    <ModuleManager />
                )}
            </main>
        </div>
    );
};

